import { render, staticRenderFns } from "./MessageForwardDropdown.vue?vue&type=template&id=db524484&"
import script from "./MessageForwardDropdown.vue?vue&type=script&lang=js&"
export * from "./MessageForwardDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MessageForwardDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports